export default __webpack_public_path__ + "static/media/imagen_landing.a2ce3f6e.png";